import { HourglassColored } from "components/icons/generated";
import Box from "ds/components/Box";
import Button from "ds/components/Button";
import Icon from "ds/components/Icon";
import Modal from "ds/components/Modal";
import ModalContent from "ds/components/Modal/Content";
import Typography from "ds/components/Typography";
import TypographyHeading from "ds/components/Typography/Heading";

type SessionHasExpiredModalModalProps = {
  isModalVisible: boolean;
  onConfirm?: () => void;
};

const SessionHasExpiredModal = ({
  isModalVisible,
  onConfirm,
}: SessionHasExpiredModalModalProps) => {
  return (
    <Modal role="alertdialog" isOpen={isModalVisible} isDismissable={false}>
      <ModalContent>
        <Box direction="column" align="center" justify="center" padding="medium" gap="x-large">
          <Icon src={HourglassColored} size="xx-large" />
          <Box direction="column" align="center" justify="center" gap="medium">
            <TypographyHeading variant="p-t5" slot="title">
              Your session has expired
            </TypographyHeading>
            <Typography variant="p-body3" tag="p" align="center">
              Click button below to log in again.
            </Typography>
          </Box>

          <Button variant="primary" onPress={onConfirm}>
            Login
          </Button>
        </Box>
      </ModalContent>
    </Modal>
  );
};

export default SessionHasExpiredModal;
